'use client';

import { Download, Zap } from 'lucide-react';

import { Row } from '@/components/layout';

import { Alert, AlertTitle } from './ui/alert';
import { Button } from './ui/button';

interface UpdateAlertProps {
    show: boolean;
    onUpdate: () => void;
}

export const UpdateAlert = ({ show, onUpdate }: UpdateAlertProps) => {
    if (!show) {
        return null;
    }

    return (
        <Alert className="flex p-4">
            <Row className="grow justify-between">
                <Row className="items-center gap-4">
                    <Zap className="size-4" />
                    <AlertTitle>A new version is available!</AlertTitle>
                </Row>
                <Button
                    className="desktop:hidden"
                    variant="outline"
                    onClick={onUpdate}
                    size="icon"
                >
                    <Download className="size-4" />
                </Button>

                <Button
                    className="desktop:flex hidden"
                    variant="outline"
                    onClick={onUpdate}
                >
                    <Download className="size-4" />
                    Update Now
                </Button>
            </Row>
        </Alert>
    );
};
